const form = {
  // form表单校验
  check: (value, callback, // form rules validator的参数
    options = {
      msg: null, // String 校验为空时的提示语 为null不校验
      len: null, // Number校验长度，Array[大于Number,小于Number]数组校验 为null不校验
      rule: null, // String 校验规则
      // rule详细规则
      // 'only-num' 只能输入数字
      // 'decimal' 只能输入数字，含小数
      // 'array' 数组
      // 'date' 日期 [ 开始时间, 结束时间 ]
      // 'ENC' 只能输入英文（English）、数字（Number）、中文（Chinese）
      // 'ENC()' 只能输入英文（English）、数字（Number）、中文（Chinese）、中英文括号
      // 'EC' 只能输入英文（English）、中文（Chinese）
      // 'EN' 只能输入英文（English）、数字（Number）
      // 'EN_' 只能输入英文（English）、数字（Number）、下划线 _
      // 'ENS' 包含英文（English）、数字（Number）、特殊符号（Special）后面可跟限制位数，例如8,20或8
      // 'email' 邮箱格式
      // 'phone' 手机号码
      // 'link' 链接地址
      ruleMsg: null, // String 替换校验规则默认提示语
      notCallBack: false, // Boolean 是否在校验通过后不调用callBack()，需要在validator中做额外校验时使用
    }
  ) => {
    let msg = options.msg;
    let len = options.len;
    let rule = options.rule;
    let ruleMsg = options.ruleMsg;
    let notCallBack = options.notCallBack;
    // 必填/必选
    if (msg) {
      if (value === '' || value === null || value === undefined) return callback(new Error(msg));
      // input textarea只有换行的情况下
      if (value && typeof value === 'string' && value.includes('\n')) {
        let textareaArr = value.split('\n');
        let flag = true;
        for (let i in textareaArr) {
          if (textareaArr[i]) flag = false;
        }
        if (flag) return callback(new Error(msg));
      }
    }
    // 长度校验
    if (len) {
      if (Array.isArray(len) && len.length === 2) {
        if (value.length < len[0]) return callback(new Error('长度小于最小限制'));
        if (value.length > len[1]) return callback(new Error('长度超出最大限制'));
      } else {
        let length = typeof value === 'number' ? String(value).length : value.length;
        if (length > len) return callback(new Error('长度超出最大限制'));
      }
    }
    // 校验规则
    if (value && rule) {
      // 'only-num' 只能输入数字，且为正整数
      if (rule === 'only-num' && !/^[0-9]\d*$/.test(value)) {
        return callback(new Error(ruleMsg || '只能输入数字，且为正整数'));
      }
      // 'decimal' 只能输入数字，含小数
      // 'decimal2' 只能输入数字，含小数点后2位（根据后面的数字决定保留小数点后几位）
      if (rule.includes('decimal')) {
        let num = rule.split('l')[1]; // 保留小数点后几位
        // 输入'100.'最后一位为小数点的情况
        if (String(value).slice(-1) === '.') {
          return callback(new Error(ruleMsg || `只能输入数字，含小数${ num ? `点后${ num }位` : '' }`));
        }
        if (num === '') { // 不限制小数点后几位
          if (!/^[+-]?(0|([1-9]\d*))(\.\d+)?$/.test(value)) {
            return callback(new Error(ruleMsg || '只能输入数字，含小数'));
          }
        } else { // 小数点后保留指定位数
          if (!new RegExp(`^[+-]?(0|([1-9]\\d*))(\\.\\d{0,${ num }})?$`).test(value)) {
            return callback(new Error(ruleMsg || `只能输入数字，含小数点后${ num }位`));
          }
        }
      }
      // 'array' 数组
      if (rule === 'array' && (!Array.isArray(value) || value?.length === 0)) {
        return callback(new Error(ruleMsg || msg || '请选择'));
      }
      // 'date' 日期 [ 开始时间, 结束时间 ]
      if (rule === 'date' && (!Array.isArray(value) || value?.length === 0 || value[0] === '' || value[1] === '')) {
        return callback(new Error(ruleMsg || msg || '请选择日期'));
      }
      // 'ENC' 只能输入英文（English）、数字（Number）、中文（Chinese）
      if (rule === 'ENC' && !/^[\u4e00-\u9fa5a-zA-Z0-9]+$/g.test(value)) {
        return callback(new Error(ruleMsg || '只能输入中文、英文、数字'));
      }
      // 'ENC()' 只能输入英文（English）、数字（Number）、中文（Chinese）、中英文括号
      if (rule === 'ENC()' && !/^[\u4e00-\u9fa5a-zA-Z0-9()（）]+$/g.test(value)) {
        return callback(new Error(ruleMsg || '只能输入中文、英文、数字、中英文括号'));
      }
      // 'EC' 只能输入英文（English）、中文（Chinese）
      if (rule === 'EC' && !/^[\u4e00-\u9fa5a-zA-Z]+$/g.test(value)) {
        return callback(new Error(ruleMsg || '只能输入中文、英文'));
      }
      // 'EN' 只能输入英文（English）、数字（Number）
      if (rule === 'EN' && !/^[a-zA-Z0-9]+$/g.test(value)) {
        return callback(new Error(ruleMsg || '只能输入英文、数字'));
      }
      // 'EN_' 只能输入英文（English）、数字（Number）、下划线 _
      if (rule === 'EN_' && !/^[a-zA-Z0-9_]+$/g.test(value)) {
        return callback(new Error(ruleMsg || '只能输入英文、数字、下划线'));
      }
      // 'ENS' 包含英文（English）、数字（Number）、特殊符号（Special）
      if (rule === 'ENS' && !/(?=.*[\d]+)(?=.*[a-zA-Z]+)(?=.*[^a-zA-Z0-9]+)/.test(value)) {
        return callback(new Error(ruleMsg || '只能输入英文、数字、特殊符号'));
      }
      // 'email' 邮箱格式
      if (rule === 'email' && !/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)) {
        return callback(new Error(ruleMsg || '请输入正确的邮箱格式'));
      }
      // 'phone' 手机号码
      if (rule === 'phone' && !/^[1][3,4,5,6,7,8,9][0-9]{9}$/g.test(value)) {
        return callback(new Error(ruleMsg || '请输入正确的联系方式'));
      }
      // 'link' 链接地址
      if (rule === 'link' && !/^(http(s?)|):\/\/(.+)$/ig.test(value)) {
        return callback(new Error(ruleMsg || '请输入正确的链接地址'));
      }
    }
    if (!notCallBack) callback();
  },
};

export default form;
